import {
  ToggleRenderer,
  FileRenderer,
  FieldRenderer,
  JsonRenderer,
} from "../components/customRenderers";
import { INTERFACES } from "../components/organisms/AppDrawers/drawers.constants";

const { BOOLEAN, IMAGE, FILE, JSON_TYPE } = INTERFACES;
const getCellRenderer = (field) => {
  switch (field.meta.interface) {
    case BOOLEAN:
      return ToggleRenderer;
    case IMAGE:
    case FILE:
      return (props) => FileRenderer(props, field);
    case JSON_TYPE:
      return (props) => JsonRenderer(props, field);
    default:
      return (props) => FieldRenderer(props, field);
  }
};

export default getCellRenderer;
